import { render, staticRenderFns } from "./NewsItemTemplate.vue?vue&type=template&id=6dff64fe&scoped=true&"
import script from "./NewsItemTemplate.vue?vue&type=script&lang=ts&"
export * from "./NewsItemTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItemTemplate.vue?vue&type=style&index=0&id=6dff64fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff64fe",
  null
  
)

export default component.exports